import { render, staticRenderFns } from "./fccListaCorrecaoCadastral.vue?vue&type=template&id=7f60873b"
import script from "./fccListaCorrecaoCadastral.vue?vue&type=script&lang=js"
export * from "./fccListaCorrecaoCadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports